<template>
  <div class="select-wrapper relative">
    <label v-if="hasDefaultSlot" :for="id" class="mb-2 block font-bold"><slot /></label>
    <div class="relative">
      <select
        class="p-5 w-full"
        :id="id"
        :class="[{'has-error' : (isValid === false)},inputClass]"
        :name="name"
        :autocomplete="autocomplete"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        @change="$emit('change', $event.target.value)"
        @input="$emit('input', $event.target.value)"
      >
        <option value disabled selected v-if="usePlaceholder">
          {{ placeholder }}
        </option>
        <option
          v-for="(option, key) in options"
          :key="key"
          :value="option.value"
          :disabled="!!option.disabled"
          v-bind="{selected: option.value === selected}"
        >
          {{ option.label }}
        </option>
      </select>
    </div>
    <ValidationMessages v-if="validations" :validations="validations" />
  </div>
</template>

<script>
import ValidationMessages from './ValidationMessages.vue'
import Validation from '../mixins/Validation.js'

export default {
  name: 'BaseSelect',
  mixins: [Validation],
  components: {
    ValidationMessages
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  },
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    selected: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    usePlaceholder: {
      type: Boolean,
      required: false,
      default: true
    },
    autocomplete: {
      type: String,
      required: false,
      default: ''
    },
    inputClass: {
      type: String,
      required: false,
      default: ''
    },
    validations: {
      type: Array,
      default: () => []
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  select {
    @apply border;
    background-color: #fff;
    background-image: var(--select-bg);
    background-repeat: no-repeat;
    background-position: right 17px center;
    margin-bottom: 0;
  }
  .select-wrapper {
    select {
      -webkit-appearance: none;
      -webkit-border-radius: 0;
      cursor: pointer;
      line-height: normal;
      @apply py-0 px-5;
    }
  }
  .has-error {
    @apply border-red;
  }
  .icon {
    position: absolute;
    right: 12px;
    top: 50%;
    margin-top: -8px;
  }
  .icon-md {
    width: 16px;
    height: 16px;
  }
</style>
